import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { thisBaseURL } from "../../utils/helper.js";
require("highcharts/modules/accessibility")(Highcharts);

function ExchangeRate({countryAnswers, countryName}){
	let defaultCountry = countryAnswers.answerKeyValues["country_code"];
	let officialExchangeRate = countryAnswers.answerKeyValues['official_exchange_rate'];
	let exchangeRateYear = countryAnswers.answerKeyValues['official_exchange_rate_year'];
	let exchangeRateSourceRef = countryAnswers.answerKeyValues['official_exchange_rate_sources'];
	let exchangeRateNotes = countryAnswers.answerKeyValues['official_exchange_rate_notes'];
	let array = [];
	let dataSeries = [];
	let xAxisCategories = [];
	if(officialExchangeRate){
		try {
			array =  JSON.parse(officialExchangeRate);
		} catch (err) {
			console.log("ExchangeRate :officialExchangeRate: " +err);
		}
		dataSeries = array.map(function (obj) {
			if(obj && obj["year"] && obj["exchange_rate"]){
				return [parseInt(obj["year"]),parseFloat(obj["exchange_rate"])];
			}
		    
		});
		xAxisCategories = array.map(function (obj) {
			if(obj && obj["year"]){
				return [parseInt(obj["year"])];
			}
		    
		});
	}
	let titleText = '';
	if(dataSeries && dataSeries.length > 0 && dataSeries[0]){
		titleText = 'Exchange Rate for '+countryName+' '+dataSeries[0][0]+' - '+dataSeries[dataSeries.length - 1][0];
	}
	
	return(
			<div className="question-grouping" id="exchange_rate">
				<h2 style={{textAlign: "center"}}>
					{titleText}
					{exchangeRateYear ? 
					<small>&nbsp;({exchangeRateYear})</small>
					: ""}
					{ exchangeRateSourceRef && exchangeRateSourceRef > 0 ?
					<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+exchangeRateSourceRef}>{exchangeRateSourceRef}</a></small>:
					""	
					}
					
				</h2>
				<HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: "60vw" } }}
				options={{
				 	title: {
						text: ''
					},
					credits: {
						enabled: false
					},
					lang: {
						thousandsSep: ','
					},
					yAxis: {
						title: {
							text: 'Exchange Rate'
						},
						plotLines: [{
							value: 0,
							width: 1,
							color: '#808080'
						}]
					},
					xAxis: {
					  categories: xAxisCategories,
			          title:  {
						text: 'Year'
				  		}
					},
					legend: {
						enabled: false,
						layout: 'vertical',
						align: 'right',
						verticalAlign: 'middle',
						borderWidth: 0
					},
					series: [{
						name: "Exchange Rate",
						data: dataSeries
						}]
				}}
				/>
				{exchangeRateNotes ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{exchangeRateNotes}</em>
				</p>
				:""}
				
			</div>
		)
}
export default ExchangeRate;